<template>
  <div>
    <WsText001
      v-for="(item, itemIndex) in items"
      :key="itemIndex"
      :h2="item.h2"
      :h3="item.h3"
      :bold="item.bold"
    >{{item.title}}</WsText001> 
  </div>
</template>

<script>
export default {
  data() {
    return {
      items: [
        {
          title: "WsText h2",
          h2: true,
        },
        {
          title: "WsText h2 bold",
          h2: true,
          bold: true,
        },
        {
          title: "WsText h3",
          h3: true,
        },
        {
          title: "WsText h3 bold",
          h3: true,
          bold: true,
        },
      ]
    }
  }
}
</script>